<template>
  <component :is="tag" v-bind="getItemAttributes()" @click="onItemClick">
    <a-link :to="item.link" class="header-mobile-bottom-section-item__wrapper">
      <a-icon
        :icon="item.icon"
        :original="true"
        :no-hover="true"
        :width="16"
        :height="16"
        class="header-mobile-bottom-section-item__icon"
      />
      <span class="header-mobile-bottom-section-item__title text-small">
        {{ item.name }}
      </span>
    </a-link>
  </component>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AIcon from 'shared/AIcon/index.vue'
import { HTML_TAG } from '@fmpedia/enums'

export default {
  name: 'HeaderMobileBottomSectionItem',
  components: { AIcon },
  props: {
    item: propValidator([PROP_TYPES.OBJECT]),
    tag: propValidator([PROP_TYPES.STRING], false, HTML_TAG.DIV)
  },
  methods: {
    getItemAttributes() {
      return this.item.attributes || {}
    },
    onItemClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-mobile-bottom-section-item__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .header-mobile-bottom-section-item__icon {
    margin-bottom: 8px;
  }

  .header-mobile-bottom-section-item__title {
    color: $c--white;
  }
}
</style>
